<template>
	<div>
		<VuePhoneNumberInput
			v-model="localPhoneNumber"
			:translations="{
				countrySelectorLabel: 'Code pays',
				countrySelectorError: 'Choisir un pays',
				phoneNumberLabel: 'Numéro de téléphone',
				example: 'Exemple :',
			}"
			no-use-browser-locale
			:preferred-countries="['FR', 'RE', 'BE']"
			v-on:update="onNumberTyping" />

		<input type="hidden" :name="inputName" :value="outputPhoneNumber" />
	</div>
</template>

<script>
	import VuePhoneNumberInput from 'vue-phone-number-input';
	import 'vue-phone-number-input/dist/vue-phone-number-input.css';
	import GInput from './GInput';

	export default {
		name: 'GInputPhoneNumber',
		components: { GInput, VuePhoneNumberInput },

		props: {
			value: {
				default: '',
				type: String,
			},
			inputName: String,
			label: String,
		},

		watch: {
			value(val) {
				this.localPhoneNumber = val;
			},
		},

		data() {
			return {
				id: this._uid,
				localPhoneNumber: '',
				outputPhoneNumber: '',
			};
		},

		mounted() {
			this.localPhoneNumber = this.value;
		},

		methods: {
			/** Decorate the numbers after typing (remove +33 and add spaces) */
			onNumberTyping(value) {
				this.$emit('input', value.formattedNumber);

				if (value.formattedNumber != null) {
					this.outputPhoneNumber = value.formattedNumber;
				}
			},

			reset() {
				this.localPhoneNumber = '';
				this.outputPhoneNumber = '';
			},
		},
	};
</script>

<style>
	@media (max-width: 480px) {
		.input-tel__label,
		.country-selector__label {
			font-size: 7px !important;
			margin-left: -5px;
		}
		.input-tel__label {
			left: 2px;
		}
		.input-tel__input {
			width: 130% !important;
			margin-left: -28px !important;
		}
		.input-tel__input::placeholder {
			/* Chrome, Firefox, Opera, Safari 10.1+ */
			font-size: 9px;
			opacity: 1; /* Firefox */
		}
		.input-tel__input:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			font-size: 9px;
		}
		.input-tel__input::-ms-input-placeholder {
			/* Microsoft Edge */
			font-size: 9px;
		}
		.country-selector__input {
			width: 78% !important;
		}
		.country-selector__toggle {
			right: 27px !important;
		}
	}
</style>
